// extracted by mini-css-extract-plugin
export default {"materialModal":"material-modal_materialModal__ZzWf2"};